const initialState = {
  listKpis2: [],
  daysOfWeek: [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ],
  filter: {
    kpisSelected: [
      "sls"
    ],
    weekDaySelected: [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ],
    selectedLocationStore: [], 
    selectedStart:null,
    selectedEnd:null,
    compareStart:null,
    compareEnd:null,
  },
};
export default initialState;
